/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Values shared by event list filter forms (URL-backed). */
export type EventListFilterFormValues = {
  name?: string
  distance: number[]
  categories: string[]
  tags: string[]
  excludeTags: string[]
  location: { name?: string; longitude?: number; latitude?: number }
  sortBy?: string
  pastEvents?: boolean
  showHosting?: boolean
  /** RHF field for the read-only location placeholder row */
  locationPlaceholder?: string
}

/** Build filter form values from route-resolved search + profile params. */
export function eventListFilterFormValuesFromResolvedParams(params: {
  name?: string
  distance?: number
  categories?: string[]
  tags?: string[]
  excludeTags?: string[]
  location?: string
  locationLat?: number
  locationLong?: number
  sortBy?: string
  pastEvents?: boolean
  showHosting?: boolean
}): EventListFilterFormValues {
  return {
    name: params.name ?? '',
    distance: [params.distance ?? 1000],
    categories: params.categories ?? [],
    tags: params.tags ?? [],
    excludeTags: params.excludeTags ?? [],
    location: {
      name: params.location,
      longitude: params.locationLong,
      latitude: params.locationLat,
    },
    sortBy: params.sortBy,
    pastEvents: params.pastEvents,
    showHosting: params.showHosting,
    locationPlaceholder: '',
  }
}
